// Modal helpers
function openModal(modal) {
  modal.style.display = "flex";
  document.body.classList.add("overflow-hidden");
}

function closeModal(modal) {
  modal.style.display = "none";
  document.body.classList.remove("overflow-hidden");
}

function bindModal(triggerId, modal, closeId) {
  document.getElementById(triggerId)?.addEventListener("click", () => openModal(modal));
  document.getElementById(closeId)?.addEventListener("click", () => closeModal(modal));
  modal?.addEventListener("click", (e) => {
    if (e.target === modal) closeModal(modal);
  });
}

const tradeModal = document.getElementById("tradeFormModal");
const consultationModal = document.getElementById("consultationFormModal");
const jobNewsletterModal = document.getElementById("jobNewsletterModal");
const jobApplicationModal = document.getElementById("jobApplicationModal");

bindModal("trade_form_button", tradeModal, "trade_form_close-button");
bindModal("consultation_form_button", consultationModal, "consultation_form_close-button");
bindModal("jobnewsletter_form_button", jobNewsletterModal, "job_newsletter_close-button");
bindModal("jobapplication_form_button", jobApplicationModal, "job_application_close-button");

// Referral source show/hide
const referralSelects = document.querySelectorAll(".referral_source select");
const referralInputs = document.querySelectorAll(".input-sub");

referralSelects.forEach((select, index) => {
  const relatedInput = referralInputs[index];
  select.addEventListener("change", function () {
    relatedInput.style.display = this.value === "Other" ? "block" : "none";
  });
});

// Checkbox multi-select (consultation form)
var expanded = false;
const otherInput = document.querySelector(".input-help_answer");

function showCheckboxes() {
  var checkboxes = document.getElementById("checkboxes");
  expanded = !expanded;
  checkboxes.style.display = expanded ? "flex" : "none";
}

function updateHelpLabel() {
  const checked = document.querySelectorAll(
    "#checkboxes input[type='checkbox']:checked",
  );
  const label = document.getElementById("help_answer_label");
  label.innerHTML = "";

  if (checked.length === 0) {
    label.textContent = "What do you need help with?";
    label.style.color = "#9999a2";
    return;
  }

  label.style.color = "#18181b";
  checked.forEach((cb) => {
    const tag = document.createElement("span");
    tag.classList.add("selected-tag");
    tag.id = `tag-${cb.id}`;
    tag.textContent = cb.value;
    label.appendChild(tag);
  });
}

document
  .querySelectorAll("#checkboxes input[type='checkbox']")
  .forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      updateHelpLabel();
      if (this.id === "four") {
        otherInput.style.display = this.checked ? "block" : "none";
        if (!this.checked) otherInput.value = "";
      }
    });
  });

// Phone input: initialize to +91 and restrict to digits
document.body.addEventListener("focusin", function (event) {
  const input = event.target.closest(".form-group-phone");
  if (input && !input.value.trim()) input.value = "+91";
});

document.body.addEventListener("input", function (event) {
  const input = event.target.closest(".form-group-phone");
  if (!input) return;
  let currentValue = input.value.replace(/[^\d+]/g, "");
  if (!currentValue.startsWith("+")) currentValue = "+91" + currentValue;
  input.value = currentValue;
});

// Validation helpers
function showError(errorEl, message, duration = 3000) {
  errorEl.textContent = message;
  errorEl.style.display = "block";
  setTimeout(() => {
    errorEl.style.display = "none";
  }, duration);
}

function clearError(errorEl) {
  errorEl.textContent = "";
  errorEl.style.display = "none";
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validateEmail(value, errorEl) {
  if (!EMAIL_PATTERN.test(value)) {
    showError(errorEl, "Please enter a valid email");
    return false;
  }
  clearError(errorEl);
  return true;
}

function validatePhoneInput(value, errorEl) {
  let v = value.replace(/[^\d+]/g, "");
  if (!v.startsWith("+")) v = "+91" + v;
  const digits = v.slice(3).trim();

  if (!digits) {
    showError(errorEl, "Please enter a valid phone number after +91.");
    return false;
  }
  if (v.startsWith("+91") && digits.length !== 10) {
    showError(errorEl, "Phone number must be exactly 10 digits.");
    return false;
  }
  clearError(errorEl);
  return true;
}

// Analytics
function fireAnalytics(eventName, title) {
  if (typeof window.fbq === "function") window.fbq("trackCustom", eventName, { title });
  if (typeof window.gtag === "function") window.gtag("event", eventName, { title });
}

// Shared form submit wiring with validation
function bindFormSubmit(formEl, onSubmit) {
  if (!formEl) return;
  formEl.addEventListener("submit", (event) => {
    event.preventDefault();
    const emailInput = formEl.querySelector(".form-group-email, #email");
    const phoneInput = formEl.querySelector(".form-group-phone");
    const emailErrorEl = formEl.querySelector("#emailError");
    const phoneErrorEl = formEl.querySelector("#phoneError");

    if (!validateEmail(emailInput.value, emailErrorEl)) return;
    if (!validatePhoneInput(phoneInput.value, phoneErrorEl)) return;

    onSubmit(new FormData(formEl));
  });
}

const submitTradeForm = document.getElementById("trade-form");
const submitConsultationForm = document.getElementById("consultation-form-id");
const submitJobNewsletterForm = document.getElementById("job-newsletter-form");
const submitJobApplicationForm = document.getElementById("job-application-form");

bindFormSubmit(submitTradeForm, tradeFormSubmit);
bindFormSubmit(submitConsultationForm, consultationFormSubmit);
bindFormSubmit(submitJobNewsletterForm, (formData) => {
  jobNewsletterFormSubmit(
    formData,
    submitJobNewsletterForm.getAttribute("data-form-type"),
  );
});
bindFormSubmit(submitJobApplicationForm, (formData) => {
  jobApplicationFormSubmit(
    formData,
    submitJobApplicationForm.getAttribute("data-form-type"),
  );
});

// API submissions
async function tradeFormSubmit(formData) {
  const d = Object.fromEntries(formData.entries());
  const payload = {
    first_name: d.first_name || "",
    last_name: d.last_name || "",
    role: d.role || "",
    phone: d.phone || "",
    location: d.location || "",
    firm_name: d.firm_name || "",
    metadata: {
      website_instagram: d.website_instagram || "",
      email: d.email || "",
    },
  };

  try {
    const response = await fetch(
      "https://oms-app.iqrupandritz.com/api/users/customers/trade-forms/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      },
    );
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    await response.json();

    fireAnalytics("JoinTrade_Form_Submit", "Join Trade Form Submitted.");
    await swal({ title: "Form submitted successfully!", icon: "success" });
    closeModal(tradeModal);
    submitTradeForm.reset();
    window.location.href = "/pages/thank-you-page-1";
  } catch {
    await swal({
      title: "Something went wrong",
      text: "Please try again later.",
      icon: "error",
    });
  }
}

async function consultationFormSubmit(formData) {
  const d = Object.fromEntries(formData.entries());
  const helpAnswers = formData.getAll("help_answer[]");
  const payload = {
    first_name: d.first_name || "",
    last_name: d.last_name || "",
    phone: d.phone || "",
    location: d.location || "",
    metadata: {
      question_answers: [
        { question: "What is your timeline?", answer: d.timeline_answer || "" },
        { question: "What do you need design help with?", answer: helpAnswers },
      ],
      need_help_details: d.help_answer_details || "",
      email: d.email || "",
    },
  };

  try {
    const response = await fetch(
      "https://oms-app.iqrupandritz.com/api/users/customers/design-consultation-forms/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      },
    );
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    await response.json();

    fireAnalytics(
      "DesignConsultation_Form_Submit",
      "Design Consultation Form Submitted.",
    );
    await swal({ title: "Form submitted successfully!", icon: "success" });
    closeModal(consultationModal);
    submitConsultationForm.reset();
    window.location.href = "/pages/thank-you-page-1";
  } catch {
    await swal({
      title: "Something went wrong",
      text: "Please try again later.",
      icon: "error",
    });
  }
}

async function jobNewsletterFormSubmit(formData, formType) {
  const d = Object.fromEntries(formData.entries());
  const payload = {
    form_type: formType,
    full_name: d.name || "",
    email: d.email || "",
    phone: d.phone || "",
    job_title: d.job_title || "",
    metadata: {},
  };

  try {
    const response = await fetch(
      "https://oms-app.iqrupandritz.com/api/users/customers/job-forms/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      },
    );
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    await response.json();

    await swal({ title: "Form submitted successfully!", icon: "success" });
    closeModal(jobNewsletterModal);
    submitJobNewsletterForm.reset();
    window.location.href = "/pages/thank-you-page-1";
  } catch {
    await swal({
      title: "Something went wrong",
      text: "Please try again later.",
      icon: "error",
    });
  }
}

async function jobApplicationFormSubmit(formData, formType) {
  const d = Object.fromEntries(formData.entries());
  const resume = formData.get("resume_file");
  const payload = {
    form_type: formType,
    full_name: d.name || "",
    email: d.email || "",
    phone: d.phone || "",
    job_title: d.job_title || "",
    portfolio_link: d.portfolio_link || "",
    metadata: {},
  };

  try {
    const response = await fetch(
      "https://oms-app.iqrupandritz.com/api/users/customers/job-forms/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      },
    );
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    const result = await response.json();

    const jobId = result?.id || result?.[0]?.id;
    if (!jobId) throw new Error("Invalid job ID received from server");

    if (resume?.name) {
      const resumeFormData = new FormData();
      resumeFormData.append("resume", resume);

      const resumeResponse = await fetch(
        `https://oms-app.iqrupandritz.com/api/users/customers/job-forms/${jobId}/`,
        { method: "PUT", body: resumeFormData },
      );
      if (!resumeResponse.ok)
        throw new Error(`Resume upload failed! Status: ${resumeResponse.status}`);
      await resumeResponse.json();
    }

    await swal({ title: "Form submitted successfully!", icon: "success" });
    closeModal(jobApplicationModal);
    submitJobApplicationForm.reset();
    window.location.href = "/pages/thank-you-page-1";
  } catch {
    await swal({
      title: "Something went wrong",
      text: "Please try again later.",
      icon: "error",
    });
  }
}
